export class TimeUsuarioDto { }
